/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Toast_Type_SetInputs */

const en_toast_type_set = /** @type {(inputs: Toast_Type_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Type set to ${i?.type}`)
};

const de_toast_type_set = /** @type {(inputs: Toast_Type_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Typ auf ${i?.type} gesetzt`)
};

/**
* | output |
* | --- |
* | "Type set to {type}" |
*
* @param {Toast_Type_SetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_type_set = /** @type {((inputs: Toast_Type_SetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Type_SetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_type_set(inputs)
	return en_toast_type_set(inputs)
});